export default "__VITE_ASSET__D6wicU$x__"